import { render } from "./Pagination1.vue?vue&type=template&id=46bf33d4"
import script from "./Pagination1.vue?vue&type=script&lang=js"
export * from "./Pagination1.vue?vue&type=script&lang=js"

import "./Pagination1.vue?vue&type=style&index=0&id=46bf33d4&lang=scss&scoped1=true"

import exportComponent from "../../../../../DIARC/texnoelm/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__